import React, { useState, useEffect } from "react";
import GenericTable from "../../../components/table";
import { Button, Grid, Box, Typography, CircularProgress } from "@mui/material";
import GenericModal from "../../../components/common/modal";
import UserForm from "./form";
import { useNavigate } from "react-router-dom";
import { UserApi } from "../../../apis";
import ChangePassword from "./changePassword";

const columns = [
  { field: "id", headerName: "ID" },
  { field: "name", headerName: "Name",sortable: true },
  { field: "email", headerName: "Email",sortable: true },
  // Flattened from role_id.name when the list is fetched — the table reads
  // row[field] directly and cannot walk into the association.
  { field: "roleName", headerName: "Role", sortable: true },
  { field: "status", headerName: "Status", sortable: true },
];

function Projects() {
  const [open, setOpen] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePasswordClose = () => {
    setOpenChangePassword(false);
  };



  const handleOpen = () => {
    setOpen(true);
  };

  const fetchUsers = async () => {
    try {
      const res = await UserApi.getAllUsers();
      const list = res.data.data.users || [];
      setUsers(list.map((user) => ({ ...user, roleName: user.role_id?.name || "—" })));
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]); // Set users to an empty array on error
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (updatedUser) => {
    try {
      await UserApi.updateUser(updatedUser); // Replace with your API call
      fetchUsers(); // Refresh the users list after updating
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await UserApi.deleteUser(id); // Replace with your API call
      fetchUsers(); // Refresh the users list after deleting
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleAssign = (id) => {
    // Handle project assignment logic here
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <Box>
      <Grid container spacing={2} mt={2} mb={2}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Typography variant="h4" fontWeight={600}>
            Users
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={6}
          display="flex"
          justifyContent="flex-end"
        >
          <Button variant="contained" color="primary" onClick={handleOpen}>
            Add User
          </Button>
        </Grid>
      </Grid>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
          <CircularProgress />
        </Box>
      ) : (
        <GenericTable
          type="users"
          data={users}
          columns={columns}
          showTimeSheet={true}
          onView={(id) => {
            navigate(`/admin/view-time-sheet/${id}`);
          }}
          onEdit={handleEdit} // Pass the edit function
          onDelete={handleDelete} // Pass the delete function
          // onAssign={handleAssign} // Pass the assign function
          fetchUsers={fetchUsers}
          assign={false} // Set assign prop to true if needed
          changePassword={true} // Set changePassword prop to true if needed
          onChangePassword= {(val) => {
            setUserId(val?.id)
            setOpenChangePassword(true)
          }}
        />
      )}
      <GenericModal
        open={open}
        handleClose={handleClose}
        title="Add User"
        handleSave={() => {
          fetchUsers(); // Refresh the users list after adding a new user
          handleClose(); // Close the modal
        }}
      >
        <UserForm fetchUsers={fetchUsers} close={handleClose} />{" "}
        {/* Pass fetchUsers as a prop */}
      </GenericModal>

      <GenericModal
        open={openChangePassword}
        handleClose={handleChangePasswordClose}
        title="Change Password"
        handleSave={() => {
          handleChangePasswordClose(); // Close the modal
        }}
      >
        <ChangePassword  userId={userId} close={handleChangePasswordClose} />{" "}
      </GenericModal>
    </Box>
  );
}

export default Projects;
